export default {"src":"/_next/static/media/GE.e65e1939.svg","height":18,"width":18};